import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';
import { FieldContextDirective } from '@app/common-codes/components/directives/FieldContext.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { AdminTenantInfoDTO } from '@app/common-codes/models/matwins-manager/AdminTenantInfoDTO.model';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { Tenant } from '@app/common-codes/models/matwins-tenant/Tenant.model';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { GuidHelpers } from '@app/common-codes/helpers/guidHelpers';


@Register(Client)
@Component({
  selector: 'app-client-detail',
  templateUrl: './client-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule, TranslatePipe, OnReadyDirective, FieldWrapperComponent, FieldContextDirective]
})
export class ClientDetailComponent extends GenetricDetailComponent<Client> {
  override ComponentEntityClass = Client;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<Client>();
  // @ViewChild('fileInput') override fileInput!: ElementRef<HTMLInputElement>;

  // @ViewChild('fileInput') declare fileInput: ElementRef<HTMLInputElement>;


  override imageRelationName = 'FK_Image_Logo';


  domainValue: string = '';
  domainError = false;
  domainTouched = false;
  private computingDomain = false;


  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    matwinsVariables: MatwinsVariablesService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;

    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        this.imageUrl = entity.relatedTenant?.imageLogo?.rawData_Path ? '/Documents/' + entity.relatedTenant.imageLogo.rawData_Path : null;

      }
    });

    effect(() => {
      const org = this.editingEntity()?.organizationName;   // on observe organizationName
      this.autoComputeDomain();                             // pour recalculer domain
    });

    let uuu = this.RequiredPermissions;
  }

  override getEmptyEntity(): Client {
    const client = new Client();
    client.isActive = true;
    client.relatedTenant = new Tenant();
    client.relatedTenant.isActive = true;
    //client.relatedTenant.prefix = '';
    //client.relatedTenant.organizationName = ''; 
    client.adminTenantInfoDTO = new AdminTenantInfoDTO();
    return client;
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }

  // get showDomainClearBtn(): boolean {
  //   const dom = this.editingEntity()?.domain;
  //   if (this.isEmpty(dom)) return false;

  //   const org = this.editingEntity()?.organizationName;
  //   return dom !== this.computeDomainValue(org ?? '');
  // }

  // get computedDomain(): string {
  //   const orgName = this.editingEntity()?.organizationName ?? '';
  //   const cleaned = orgName
  //     .toLowerCase()
  //     .normalize('NFD')
  //     .replace(/[\u0300-\u036f]/g, '')
  //     .replace(/[^a-z0-9]/g, '');

  //   return this.domainValue || cleaned;
  // }


  public isEmpty(str: any): boolean {
    return str == null || str === '';
  }

  // calculee 'domain' depuis orgName 
  private computeDomainValue(orgName: string): string {
    if (!orgName) return '';
    return orgName
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }


  validateDomain(value: string): void {
    if (value)
      this.domainError = !/^[a-z0-9]*$/.test(value);
    else
      this.domainError = false;
  }

  override validateForm(): boolean {
    const baseValid = super.validateForm();
    const dom = this.editingEntity()?.prefix;
    this.validateDomain(dom ?? '');
    return baseValid && !this.domainError;
  }


  private autoComputeDomain(): void {
    if (this.computingDomain) return;   // saisie en cours
    const organization = this.editingEntity()?.organizationName;
    const domain = this.editingEntity()?.prefix;

    if (!this.isEmpty(organization) && !this.hasValidationErrors('organizationName')) {

      if (this.isEmpty(domain) || (!this.isEmpty(domain) && domain != this.computeDomainValue(organization || ''))) {
        this.computingDomain = true;
        const calculatedValue = this.computeDomainValue(organization || '');
        this.updateEditingEntity('prefix', calculatedValue);
        this.validateDomain(calculatedValue);
        this.updateEditingEntity('url', `https://${calculatedValue}.${this.matwinsVariables.domainMatwins}`);
        this.updateEditingEntity('relatedTenant.prefix', calculatedValue);
        this.updateEditingEntity('relatedTenant.organizationName', organization);

        this.computingDomain = false;

      }

    }
    // else if (this.isEmpty(organization) && !this.isEmpty(domain)) {
    //   this.computingDomain = true;
    //   this.updateEditingEntity('domain', '');
    //   this.updateEditingEntity('url', '');
    //   this.updateEditingEntity('relatedTenant.prefix', '');
    //   this.updateEditingEntity('relatedTenant.organizationName', '');
    //   this.computingDomain = false;
    // }
  }

  override updateEditingEntity(property: string, value: any): void {
    super.updateEditingEntity(property, value);     // fait le vrai travail

    if (property === 'organizationName') {
      this.autoComputeDomain();                     // recalcule si besoin
    } else if (property === 'prefix') {
      this.validateDomain(value ?? '');
    }
  }


  // onDomainInput(value: string): void {
  //   if (value == '')
  //     value = ' ';

  //   this.domainValue = value;
  // }

  // onDomainBlur(): void {
  //   const val = this.domainValue;
  //   this.domainError = !/^[a-z0-9]*$/.test(val);
  //   if (!this.domainError || val.trim().length == 0) {
  //     this.updateEditingEntity('domain', val);
  //     this.updateEditingEntity('url', `https://${val}.${this.matwinsVariables.domainMatwins}`);
  //     this.updateEditingEntity('relatedTenant.prefix', val);
  //     this.updateEditingEntity('relatedTenant.organizationName', this.editingEntity()?.organizationName);
  //   }
  // }


  override bindingHandler(el: HTMLElement, field: string): void {
    const input = el as HTMLInputElement;

    if (field === 'prefix') {
      // valeur initiale
      const model = this.editingEntity();
      const currentDom = this.getPropertyValue(model, 'prefix');
      if (this.isEmpty(currentDom)) {
        this.autoComputeDomain();          // va remplir + valider
      } else {
        input.value = currentDom;
        this.validateDomain(currentDom);
      }

      if (!(el as any).__matwinsClientBound) {
        (el as any).__matwinsClientBound = true;
        // saisie
        input.addEventListener('input', (e: Event) => {
          const v = (e.target as HTMLInputElement).value;
          this.ngZone.run(() => {
            this.updateEditingEntity('prefix', v);
            this.updateEditingEntity('url', `https://${v}.${this.matwinsVariables.domainMatwins}`);
            this.updateEditingEntity('relatedTenant.prefix', v);
            this.updateEditingEntity('relatedTenant.organizationName', this.editingEntity()?.organizationName);
          });
        });

        this.registerViewModelProperty('prefix');
      }
      return;
    }

    super.bindingHandler(el, field); // autres champs
  }


  clearDomain(): void {
    this.updateEditingEntity('prefix', null);
    //this.domainTouched = false;
    //this.autoComputeDomain();          // recalcule si orgName OK
  }

  async performBeforeSave() {
    let entity = this.editingEntity();
    if (entity) {
      if (this.matwinsVariables.clientId === null || this.matwinsVariables.clientId === undefined) {
        this.matwinsVariables.clientId = entity.id;
      }
      if (entity.relatedTenant) {
        entity.relatedTenant.pointOfServices = undefined;
        entity.relatedTenant.isActive = entity.isActive;
      }
      entity.relatedAccounts = undefined;
    }
  }

  async saveItem(): Promise<void> {

    //// CODE A SUPPRIMER =====================
    //// Code qui sert a

    //const suffix = this.editingEntity()?.organizationName.toLowerCase().split(' ').join(''); 

    //this.isNew.set(true);
    //const newAdmin = new AdminTenantInfoDTO();
    //newAdmin.FullName = `John Doe-${suffix}`;
    //newAdmin.Email = `john@example.${suffix}.com`;
    //newAdmin.Password = 'SecurePass123!';
    //newAdmin.ConfirmPassword = 'SecurePass123!';

    //this.editingEntity.update(current => {
    //  if (!current) return null;

    //  // Cloner le Client (shallow copy)
    //  const updated = Object.assign(new Client(), current);
    //  updated.adminTenantInfoDTO = newAdmin;
    //  return updated;
    //});
    //// =======================================
    await this.performBeforeSave();
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }


  // override resetImage(): void {
  //   this.imageUrl = null;
  //   if (this.fileInput) {
  //     this.fileInput.nativeElement.value = '';
  //   }
  // }

  override enterEditMode(): void {
    this.validationErrors.set({});
    if (this.EntityInstance && !GuidHelpers.isEmptyGuid(this.EntityInstance.id)) {
      this.isNew.set(false);
      this.editingEntity.set(Object.assign(this.getEmptyEntity(), this.EntityInstance));
      this.isEditMode.set(true);
    }
    else {
      this.isNew.set(true);
      this.editingEntity.set(this.EntityInstance);
    }
  }


}
